import React from "react";
import { func, number } from "prop-types";
import {
  isLastPage,
  isFirstPage,
  totalPages,
  pageBlock,
} from "../../data/paging.js";

const propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired,
};

const Pagination = props => {
  const { totalResults, resultsPerPage, handlePageChange } = props;
  const currentPage = Number(props.currentPage); // Ensure currentPage is a number

  const block = pageBlock(totalResults, resultsPerPage, currentPage);
  const isLast = isLastPage(totalResults, resultsPerPage, currentPage);
  const isFirst = isFirstPage(currentPage);
  const lastPage = totalPages(totalResults, resultsPerPage);

  const getPage = (label, value, isDisabled, isEndcap) => {
    return (
      <button
        className={`btn btn--link ${isEndcap ? "btn--endcap" : ""}`}
        key={label ?? isEndcap}
        type="button"
        aria-current={isDisabled}
        onClick={() => onPageClick(value, isDisabled)}
        disabled={isDisabled}
      >
        {isEndcap === "last" ? (
          <i className="fa fa-caret-right" aria-hidden="true"></i>
        ) : isEndcap === "first" ? (
          <i className="fa fa-caret-left" aria-hidden="true"></i>
        ) : (
          label
        )}
      </button>
    );
  };

  const onPageClick = (pageNum, isDisabled) => {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  };

  const renderPageNumbers = () => {
    if (lastPage <= 5) {
      // Render all pages if 5 or fewer
      return block.map(page => {
        return getPage(page.label, page.num, page.current);
      });
    } else {
      // Render condensed pagination with ellipses
      const pages = [];

      // First page
      pages.push(getPage("1", 1, currentPage === 1));

      // First ellipsis (if needed)
      if (currentPage > 3) {
        pages.push(
          <span key="ellipsis-1" className="pagination__ellipsis">
            ...
          </span>,
        );
      }

      // Previous page (if not already shown)
      if (currentPage > 2 && currentPage > 1) {
        pages.push(getPage(currentPage - 1, currentPage - 1, false));
      }

      // Current page (if not page 1)
      if (currentPage !== 1 && currentPage !== lastPage) {
        pages.push(getPage(currentPage, currentPage, true));
      }

      // Next page (if not already shown)
      if (currentPage < lastPage - 1 && currentPage < lastPage) {
        pages.push(getPage(currentPage + 1, currentPage + 1, false));
      }

      // Last ellipsis (if needed)
      if (currentPage < lastPage - 2) {
        pages.push(
          <span key="ellipsis-2" className="pagination__ellipsis">
            ...
          </span>,
        );
      }

      // Last page (if not already shown)
      if (lastPage !== 1) {
        pages.push(getPage(lastPage, lastPage, currentPage === lastPage));
      }
      return pages;
    }
  };

  return (
    <div className="pagination">
      <nav aria-label="Pagination" className="pagination__pages">
        {getPage("", currentPage - 1, isFirst, "first")}
        <div className="pagination__page-numbers">{renderPageNumbers()}</div>
        {getPage("", currentPage + 1, isLast, "last")}
      </nav>
    </div>
  );
};

Pagination.propTypes = propTypes;
export default Pagination;
